module.exports = __webpack_public_path__ + "static/media/trash-blue.dab364a0.svg";